import React from "react";
import ProductDetails from "../components/productDetail/productDetail";
import { SEO } from "../components/seo";

const Details = ({ pageContext, location }) => {
  return <ProductDetails pageContext={pageContext} location={location} />;
};

export default Details;
export const Head = ({ location, pageContext }) => (
  <SEO
    canonical={`https://www.salvex.com${location.pathname}`}
    title={pageContext?.product?.title ? pageContext?.product?.title + " | Salvex" : "Listing Detail | Salvex"}
    description={`${
      pageContext?.selectedCat?.data?.meta_description ? pageContext?.selectedCat?.data?.meta_description + " - " : ""
    } ${pageContext?.product?.title ? pageContext.product.title : ""}`}
    image={
      pageContext?.product?.image
        ? pageContext?.product?.image
        : pageContext?.product?.primary_picture
        ? pageContext?.product?.primary_picture.replace("_sp.", "_lp.")
        : "https://media.salvex.com/auction/p/1830079/183007825_698229_lp.jpg"
    }
    article="website"
  />
);
